import { useClientSelectedStore } from "presentation/stores/use-client-selected-store";
import { useFilterClientStore } from "presentation/stores/use-filter-client-store";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const HeaderClientGrid: React.FC = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const { filters, setFilters, resetFilters } = useFilterClientStore();
  const navigate = useNavigate();
  const { resetClient } = useClientSelectedStore();

  const clearFilter = () => {
    resetFilters();
    setGlobalFilterValue("");
    setFilters({
      query: { value: "", matchMode: "contains" },
      name: { value: "", matchMode: "contains" },
      city: { value: "", matchMode: "contains" },
      type: { value: "", matchMode: "contains" },
    });
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      let _filters = { ...filters };
      // @ts-ignore
      _filters["query"].value = globalFilterValue;
      setFilters(_filters);
    }
  };

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGlobalFilterValue(e.target.value);
  };

  const addClient = () => {
    resetClient();
    navigate("/clients/new");
  };

  return (
    <div className="flex justify-content-between">
      <div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            onKeyDown={onKeyDown}
            placeholder="Search"
          />
        </IconField>
      </div>
      <div style={{ display: "flex" }}>
        <Button
          type="button"
          icon="pi pi-plus"
          label="Novo Cliente"
          outlined
          onClick={addClient}
          style={{
            backgroundColor: "#2196f3",
            color: "white",
            borderRadius: "8px",
          }}
        />
        <div style={{ width: "10px" }}></div>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};
export default HeaderClientGrid;
